'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const { shape, object } = PropTypes
var object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  query: object,
  page: object
}), (0, _withHandlers2.default)({
  downloadQuery: function downloadQuery(_ref) {
    var query = _ref.query,
        page = _ref.page;
    return function () {
      var queryString = JSON.stringify(query);
      // eslint-disable-next-line
      var url = '/api/stream/data?type=xlsx&model=' + page.view + '&query=' + queryString + '&fieldNaming=name&removeSysFields=true';
      window.open(url);
    };
  }
}), (0, _exposeProps2.default)(['downloadQuery']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'controlToolButton');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/controlToolButton/index.js
// module id = 1347
// module chunks = 0